export const EXPORT_ALL = "all"

export const ACCESS_ATTRIBUTE = [
  "type",
  "date",
  "range",
  "overview_range",
  "date_gteq",
  "date_lteq",
  "crew_ids[]",
  "include_unassigned",
  "payment_type",
  "booking_type",
  "transaction_type",
  "experience",
  "category_id",
  "page",
  "per_page",
  "search",
  "label_ids"
]

export const DEFAULT_TYPE = "business_overview"

export const TYPE_OPTIONS_ENUM = {
  business_overview: "Business Overview",
  expenses: "Expenses",
  sales: "Sales",
  // tip_report: "Tip Report"
}

export const DEFAULT_RANGE = "month"

export const RANGE_OPTIONS = {
  month: "Month",
  week: "Week",
  date: "Day"
}

export const OVERVIEW_RANGE_OPTIONS = {
  current_month: "Current month",
  last_month: "Last month",
  last_30_days: "Last 30 days",
  total_by_scope: "Custom date range"
}

export const DETAILS_RANGE_OPTIONS = [
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
  { label: "Custom", value: "custom" }
]

export const TYPE_WITH_DATESWITCHER = ["all", "expenses", "sales", "tip_report"]
export const SCOUP_LIST = ["expenses", "sales"]

export const STATS_NAMES = {
  all: "profit",
  expenses: "expenses",
  sales: "incomes"
}

export const CATEGORY_ICONS = {
  "equipment-gear": "boat",
  "legal-professional": "bag",
  fuel: "fuel",
  insurance: "insurance",
  licenses: "license",
  maintenance: "maintenance",
  memberships: "membership",
  "slip-marine-fees": "boat",
  lodging: "accomodation",
  accomodation: "accomodation",
  other: "other",
  Advertising: "advertising",
  "food-and-beverages": "food",
  "staff-and-labor": "staff"
}

export const RECURRING_TYPE = ["Monthly", "Yearly"]

export const FILTER_PARAM_KEYS = ["payment_type", "booking_type", "transaction_type", "experience", "category_id", "label_ids"]

export const PAYMENT_TYPE_OPTIONS = [
  { value: "card", label: "Card" },
  { value: "cash", label: "Cash" },
  { value: "paypal", label: "PayPal" }
]

export const BOOKING_TYPE_OPTIONS = [
  { value: "manual", label: "Manual" },
  { value: "marketplace", label: "Marketplace" },
  { value: "embedded", label: "Embed" },
  { value: "website", label: "Website" },
  { value: "chatbot", label: "ChatBot" }
]

export const TRANSACTION_TYPE_OPTIONS = [
  { value: "deposit", label: "Deposit" },
  { value: "full_payment", label: "Full Payment" },
  { value: "balance_paid", label: "Balance Paid" },
  { value: "partial_refunded", label: "Partial Refunded" },
  { value: "fully_refunded", label: "Fully Refunded" }
]
